
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ordini-import-taylor-made",
      function () {
        return require("private-next-pages/ordini-import-taylor-made/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ordini-import-taylor-made"])
      });
    }
  